export default {
    state: {
        popups: [],
        lastID: 0,

        showPopupName: null,
        confirmedPopupMethod: null,
        confirmedPopupMessage: null,
    },
    getters: {
        POPUPS: (state) => {
            return state.popups;
        },
        SHOP_POPUP_NAME: (state) => {
            return state.showPopupName;
        },
        CONFIRMED_POPUP_METHOD: (state) => {
            return state.confirmedPopupMethod;
        },
        CONFIRMED_POPUP_MESSAGE: (state) => {
            return state.confirmedPopupMessage;
        },
    },
    mutations: {
        POPUP_ADD: (
            state,
            { title, description, color, isLongPopup = false }
        ) => {
            state.popups.push({
                id: state.lastID,
                title: title,
                description: description,
                color: color,
                isLongPopup: isLongPopup,
            });
            state.lastID += 1;
        },
        POPUP_DELETE: (state, id) => {
            const searchPopupIndex = state.popups
                .map((popup) => popup.id)
                .indexOf(id);
            if (searchPopupIndex >= 0) state.popups.splice(searchPopupIndex, 1);
        },

        SHOP_POPUP_NAME: (state, payload) => {
            state.showPopupName = payload;
        },
        CONFIRMED_POPUP_METHOD: (state, payload) => {
            state.confirmedPopupMethod = payload;
        },
        CONFIRMED_POPUP_MESSAGE: (state, payload) => {
            state.confirmedPopupMessage = payload;
        },
    },
    actions: {},
};
